import { createContext, useContext, useState, useEffect } from "react";
import axiosClient from '../front/axiosClient';
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext(null);
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [notification, setNotification] = useState([]);
    const [loading, setLoading] = useState(true);
    // Load user from localStorage on app start
    const fetchUser = async () => {
        try {
          const res = await  axiosClient.get("/auth/get-auth-user.php"); 
          setUser(res.data.user);
        } catch (err) {
          setUser(null);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        fetchUser(); 
      }, []);

    const getAvatarUrl = (name) =>
        `https://ui-avatars.com/api/?name=${encodeURIComponent(
            name || "Geast User"
        )}&background=random&color=fff&rounded=true`;

    const avatar = getAvatarUrl(user?.name);

    useEffect(() => {
        if (!user?.id) return;
        const fetchNotification = async () => {
            const res = await axiosClient.get(
                `/notify/notification.php?id=${user.id}`
            );
            setNotification(res.data.data || []);
        };

        fetchNotification();
    }, [user]);
    return (
        <AuthContext.Provider value={{ user, setUser, loading, avatar, notification, setNotification}}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
